import {css, unsafeCSS} from 'lit';
import {SpAnimationFactory, SpAnimationOptions} from "./animation.interfaces";

export const pulsateAnimation: SpAnimationFactory<SpPulsateAnimationOptions> = (options?) => {
    options = {
        minScale: 0.8,
        maxScale: 1.1,
        minOpacity: 1,
        maxOpacity: 1,
        delay: 0,
        duration: 2,
        steadyPulse: false,
        iterationCount: 'infinite',
        ...options
    }
    // language=CSS
    return css`
        .${ unsafeCSS(options.className ? options.className : 'pulsate-animation') } {
          animation: ${ unsafeCSS(options.className ? `${options.className}-frames` : 'pulsate-animation-frames') } linear;
          animation-duration: ${ unsafeCSS(options.duration) }s;
          animation-delay: ${ unsafeCSS(options.delay) }s;
          animation-iteration-count: ${ unsafeCSS(options.iterationCount) };
        }

        .${ unsafeCSS(options.classNameOnce ? options.classNameOnce : 'pulsate-once-animation') } {
            animation: ${ unsafeCSS(options.className ? `${options.className}-frames` : 'pulsate-animation-frames') } linear;
            animation-duration: ${ unsafeCSS(options.duration) }s;
            animation-delay: ${ unsafeCSS(options.delay) }s;
            animation-iteration-count: 1;
        }
        
        @keyframes ${ unsafeCSS(options.className ? `${options.className}-frames` : 'pulsate-animation-frames') } {
            ${ unsafeCSS(options.steadyPulse ? `
            0%   {
                opacity: ${ options.maxOpacity };
                transform: scale(${ options.minScale });
            }
            50%  {
                opacity: ${ options.minOpacity };
                transform: scale(${ options.maxScale });
            }
            100% {
                opacity: ${ options.maxOpacity };
                transform: scale(${ options.minScale });
            }` : `
            0%   {
                opacity: ${ options.maxOpacity };
                transform: scale(1);
            }
            40% {
                opacity: ${ options.maxOpacity };
                transform: scale(1);
            }
            50%  {
                opacity: ${ options.minOpacity };
                transform: scale(${ options.minScale });
            }
            60% {
                opacity: ${ options.maxOpacity };
                transform: scale(${ options.maxScale });
            }
            100% {
                opacity: ${ options.maxOpacity };
                transform: scale(1);
            }`) }
        }
`;
}

export interface SpPulsateAnimationOptions extends SpAnimationOptions {
    classNameOnce?: string;
    steadyPulse?: boolean;
    minScale?: number;
    maxScale?: number;
    minOpacity?: number;
    maxOpacity?: number;
    initialScaleFactor?: number;
}